/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { challengeTranslationSchema } from '../challenge-translation-schema';

export const listChallengeTranslationsResponseDataSchema = z.array(challengeTranslationSchema);

export type IListChallengeTranslationsResponseData = z.infer<
  typeof listChallengeTranslationsResponseDataSchema
>;

export const listChallengeTranslationsResponseSchema = createApiResponseSchema(
  listChallengeTranslationsResponseDataSchema,
) as z.ZodSchema<IAPI<IListChallengeTranslationsResponseData>>;

export type IListChallengeTranslationsResponse = IAPI<IListChallengeTranslationsResponseData>;
